export const calculateRemainingStock = (product, purchases) => {
  const soldQuantity = purchases.reduce((total, purchase) => {
    return (
      total +
      purchase.items.reduce((itemTotal, item) => {
        return item.productId === product.id
          ? itemTotal + item.quantity
          : itemTotal
      }, 0)
    )
  }, 0)
  return (product.initialStock || 0) - soldQuantity
}

export const filterByDateRange = (items, startDate, endDate) => {
  if (!startDate && !endDate) return items

  return items.filter((item) => {
    const itemDate = new Date(item.date || item.createdAt)
    const start = startDate ? new Date(startDate) : new Date('1970-01-01')
    const end = endDate ? new Date(endDate + 'T23:59:59') : new Date()

    return itemDate >= start && itemDate <= end
  })
}
